import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(customParseFormat); // need this because we receive non-standard date strings from some apis
dayjs.extend(isSameOrBefore);

type DateToParse = string | number | dayjs.Dayjs | Date | null;

export const formatDate = (formatString?: string, date = new Date()) => dayjs(date).format(formatString);
export const parseDate = (dateToParse?: DateToParse, formatString?: dayjs.OptionType) => dayjs(dateToParse, formatString).toDate();
export const addDaysToDateAndFormat = (originalDate: DateToParse, daysToAdd: number, formatString = 'MMM DD, YYYY') =>
  dayjs(originalDate).add(daysToAdd, 'day').format(formatString);
export const isTodayWithinNDaysAfterDate = (originalDate: DateToParse, nDays: number) =>
  dayjs().isSameOrBefore(dayjs(originalDate).add(nDays, 'day'));
export const extractShortMonthDayFromDate = (originalDate?: string) => {
  if (!originalDate) return;
  const parts = originalDate.split(',');
  return parts[0]?.trim();
};
export const parseDateFromMiliseconds = (originalDate: any, noYear: boolean) => {
  const date = new Date(originalDate);

  return noYear
    ? date.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit'
      })
    : date.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric'
      });
};

export const getIsPastSixtyDays = (orderDate: string) => {
  const parsedOrderDate = dayjs(orderDate.split(' at ')[0]);

  const RETURN_STORE_CREDIT_START_DATE = dayjs('2025-06-01'); // TODO - remove start date logic after date is passed.
  // If current date is before start date, return false
  if (dayjs().isBefore(RETURN_STORE_CREDIT_START_DATE)) {
    return false;
  }

  // order date is before start date, always return false
  if (parsedOrderDate.isBefore(RETURN_STORE_CREDIT_START_DATE)) {
    return false;
  }

  // orders on or after start date, check if it's past 60 days
  const isWithin60Days = isTodayWithinNDaysAfterDate(parsedOrderDate, 60);
  return !isWithin60Days;
};
